import useGenerateInvoicesMutation from '@/api/mutations/useGenerateInvoicesMutation';
import useProcessInvoiceTransactionsMutation from '@/api/mutations/useProcessInvoiceTransactionsMutation';
import Button from '@/components/Button';
import CustomToast from '@/components/CustomToast';
import toast from 'react-hot-toast';

const BillingActionButtons = () => {
  const generateInvoices = useGenerateInvoicesMutation();
  const processInvoiceTransactions = useProcessInvoiceTransactionsMutation();

  const handleGenerateInvoices = async () => {
    try {
      const result = await generateInvoices.mutateAsync();

      toast.custom((t) => (
        <CustomToast
          id={t.id}
          message={`Generated ${result.generated} invoice${result.generated === 1 ? '' : 's'}.`}
          visible={t.visible}
        />
      ));
    } catch (error) {
      console.error('Failed to generate invoices:', error);
    }
  };

  const handleProcessInvoiceTransactions = async () => {
    try {
      const result = await processInvoiceTransactions.mutateAsync();

      toast.custom((t) => (
        <CustomToast
          id={t.id}
          message={`Processed ${result.processed} invoice transaction${result.processed === 1 ? '' : 's'}.`}
          visible={t.visible}
        />
      ));
    } catch (error) {
      console.error('Failed to process invoice transactions:', error);
    }
  };

  return (
    <>
      <Button
        variant="secondary"
        onClick={handleGenerateInvoices}
        loading={generateInvoices.isPending}
        data-testid="admin-generate-invoices-button"
      >
        Generate Invoices
      </Button>
      <Button
        onClick={handleProcessInvoiceTransactions}
        loading={processInvoiceTransactions.isPending}
        data-testid="admin-process-invoice-transactions-button"
      >
        Process Invoice Transactions
      </Button>
    </>
  );
};

export default BillingActionButtons;
